import React from 'react';

import Loader from 'utils/Loader';
import { BASE_URL } from 'Service/ApiService';
import { Typography, Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '../../../node_modules/@mui/material/index';
import SalesOrderUploadController from 'pages/Controller/SalesOrderUploadController';

function SalesOrderUpload() {
  const { loading, divisionSummary, dataNotFound, handleFileChange, handleUpload, fileInputRef } = SalesOrderUploadController();

  const handleDownload = () => {
    window.location.href = BASE_URL + 'uploads/sample_sales_order.csv';
  };

  return (
    <div className="center-container">
      {loading && (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Please wait...</span>
        </div>
      )}
      <div className="white-box">
        <h2 style={{ fontWeight: 'medium', textAlign: 'center' }}>Sales Order Upload</h2>
        <div style={{ marginTop: '10px', marginBottom: '10px', float: 'right' }}>
          <button className="sample-download-button" onClick={handleDownload}>
            Sample CSV
          </button>
        </div>
        <div style={{ marginTop: '10px' }}>
          <form onSubmit={handleUpload}>
            <div style={{ marginBottom: '20px' }}>
              <label htmlFor="fileInput" style={{ fontWeight: 'bold', fontSize: '0.75rem', display: 'block', marginBottom: '4px' }}>
                Select File
              </label>
              <input type="file" id="fileInput" onChange={handleFileChange} ref={fileInputRef} className="upload-input" accept=".csv" />
            </div>

            {/* {alert &&
            <div style={{ textAlign: 'left', marginBottom: '10px' }}>
              <span style={{color:`${severity}`}}>{message}</span>
            </div>
          } */}

            <Box p={2}>
              <Typography variant="overline" display="block" color="#770000E6">
                <strong>Required Field -</strong> partyCode, mCatID, VTWEG, materialCode, materialDesc, chart, shade, grade, materialSize,
                qty, remarks, OrderReason, DelDate
              </Typography>
            </Box>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button className="soft-button" type="submit" disabled={loading}>
                UPLOAD
              </button>
            </div>
          </form>

          {(divisionSummary.length > 0 || dataNotFound.length > 0) && (
            <div style={{ marginTop: '24px' }}>
              <h3 style={{ fontWeight: 'medium', textAlign: 'center' }}>
                Summary
              </h3>
              {divisionSummary.length > 0 && (
                <>
                  <h4>Division Corrections Applied</h4>
                  <TableContainer component={Paper} elevation={0}>
                    <Table size="small" aria-label="Division correction summary">
                      <TableHead>
                        <TableRow>
                          <TableCell><strong>Row No.</strong></TableCell>
                          <TableCell><strong>Material Code</strong></TableCell>
                          <TableCell><strong>Uploaded orgDivision</strong></TableCell>
                          <TableCell><strong>Corrected orgDivision</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {divisionSummary.map((summary, index) => (
                          <TableRow key={`${summary.lineNumber}-${summary.materialCode || index}`}>
                            <TableCell>{summary.lineNumber}</TableCell>
                            <TableCell>{summary.materialCode}</TableCell>
                            <TableCell>{summary.uploadedDivision}</TableCell>
                            <TableCell>{summary.correctedDivision}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}

              {dataNotFound.length > 0 && (
                <div style={{ marginTop: '24px' }}>
                  <h4>Materials not found</h4>
                  <p>The following materials could not be matched with a valid division and were excluded from the order.</p>
                  <TableContainer component={Paper} elevation={0}>
                    <Table size="small" aria-label="Materials not found">
                      <TableHead>
                        <TableRow>
                          <TableCell><strong>CSV Row</strong></TableCell>
                          <TableCell><strong>Material Code</strong></TableCell>
                          <TableCell><strong>Size</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dataNotFound.map((material, index) => (
                          <TableRow key={`${material.lineNumber}-${material.materialCode || index}`}>
                            <TableCell>{material.lineNumber}</TableCell>
                            <TableCell>{material.materialCode}</TableCell>
                            <TableCell>{material.sizex}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SalesOrderUpload;
